import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { signIn, auth } from './firebase';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { db, onSnapshot, doc} from './firebase';
 
const GlobalStyle = createGlobalStyle`
  body {
    font-family: Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Lato, Ubuntu, Cantarell, "Helvetica Neue", "sans-serif";
  }

  .CodeMirror {
  /* our container wrapper for Codemirror instance */
  
  height: 70vh;
  position: relative; /* needed for child component .cm-scroller */
}

.cm-scroller {
  position: absolute !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
`;

const Header = styled.div`
  background-color: #000;
  position: fixed;
  top: 0;
  left:0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  margin: 0;
  text-align: center;
  color: #fff;
  display:flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  width:120px;
`;

const Version = styled.div`
  font-size: 10px;
  margin-left: 10px;
  color:#979797;
  font-style: italic;
  font-weight:200;
  margin-top:2px;
  text-transform: uppercase;

`;

const Avatar = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  
  cursor: pointer;

  img {
    border-radius: 50%;
    width: 32px;
    height: 32px;
  }
`;

const Dropdown = styled.ul`
  position: absolute;
  top: 40px;
  right: 0;
  z-index: 1;
  padding: 0;
  margin: 0;
`;

const DropdownItem = styled.li`
  list-style: none;
  background-color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #f2f2f2;
  }
`;


const LoginLink = styled(Link)`
  display: inline-block;
  padding: 8px 16px;
  background-color: #fff;
  color: #000;
  border-radius: 4px;
  text-decoration: none;
`;

const Main = styled.div`
  margin-top: 60px;
  padding:20px;
`



const logo = `data:image/png;base64,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`


function Layout({ children }) {
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [version, setVersion] = useState('');

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
    
    onSnapshot(doc(db, "system", "version"), (doc) => {
      setVersion(doc.data().number);
    });
  }, []);

  

  const handleAvatarClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="App">
      <GlobalStyle />
      <Header>
        <Title>
          <Logo alt="Proluxe AI" src={logo} />
          <Version>Version {version}</Version>
        </Title>
        {user ? (
          <Avatar onClick={handleAvatarClick}>
            <img src={user.photoURL} alt="User Avatar" />
            {dropdownOpen && (
              <Dropdown ref={dropdownRef}>
                <DropdownItem>
                  <Link to="/knowledge">Manage Documents</Link>
                </DropdownItem>
                <DropdownItem>
                  <Link to="/">Chat</Link>
                </DropdownItem>
              </Dropdown>
            )}
          </Avatar>
        ) : (
          <LoginLink onClick={() => signIn()}>Log in</LoginLink>
        )}
      </Header>

      <Main>
        {children}
      </Main>
    </div>
  );
}

export default Layout;
